import axios from "axios";

const API = "/api";

export const fetchCoverageLocations = async ({
  search = "",
  status = "all",
  lang = "ar",
  includeHidden = false,
  adminPassword = "",
} = {}) => {
  const response = await axios.get(`${API}/coverage-locations`, {
    params: {
      search,
      status,
      lang,
      include_hidden: includeHidden,
    },
    headers: includeHidden && adminPassword ? { "x-admin-password": adminPassword } : {},
  });
  return response.data;
};

export const verifyCoverageAdmin = async ({ adminPassword }) => {
  const response = await axios.get(`${API}/coverage-admin/verify`, {
    headers: {
      "x-admin-password": adminPassword,
    },
  });
  return response.data;
};

export const createCoverageLocation = async ({ data, adminPassword }) => {
  const response = await axios.post(`${API}/coverage-locations`, data, {
    headers: {
      "x-admin-password": adminPassword,
    },
  });
  return response.data;
};

export const updateCoverageLocation = async ({ locationId, data, adminPassword }) => {
  const response = await axios.put(`${API}/coverage-locations/${locationId}`, data, {
    headers: {
      "x-admin-password": adminPassword,
    },
  });
  return response.data;
};

export const deleteCoverageLocation = async ({ locationId, adminPassword }) => {
  const response = await axios.delete(`${API}/coverage-locations/${locationId}`, {
    headers: {
      "x-admin-password": adminPassword,
    },
  });
  return response.data;
};
